<i18n>
{
  "fr": {
      "infoEquipement": "Ce(s) équipement(s) est(sont)",
      "attachementTitle": "Liste des pièces jointes",
      "conclusion": "Conclusion",
      "loading": "Chargement...",
      "typeOfInvestigation":"Type enquête",
      "dessinTech": "Dessin technique",
      "chooseContact": "Choisissez un contact",
      "signataire":"Signataire",
      "addSignature":"Ajouter la signature",
      "signature":"Signature",
      "technical_drawings": "Dessin Technique",
      "open_technical_drawing": "Ouvrir le dessin technique",
      "open_synoptic_drawing": "Ouvrir le synoptique",
      "download": "Télécharger",
      "controleRemarque": "Autres remarques sur le contrôle"
  }
}
</i18n>
<template>
  <div>
    <filesDropzone name="filesDropzone" />
    <div class="panel panel-info mg-b-15">
      <div class="panel-heading">
        <h3>{{ title}}</h3>
      </div>
      <div class="panel-body">
        <b-form-group
          label="Date de visite"
          label-for="dateOfVisit"
          label-cols="5"
          class="form-table"
        >
          <b-form-input
            id="dateOfVisit"
            name="dateOfVisit"
            type="date"
            v-model="conformiteForm.dateOfVisit"
            button-variant="outline-info"
            class="form-control"
          />
          <span class="input-group-addon">
            <i class="fa fa-calendar"></i>
          </span>
        </b-form-group>

        <b-form-group label="Rapporteur" label-cols="5" label-for="protractor">
          <b-form-input
            id="protractor"
            name="protractor"
            type="text"
            :maxlength="$MAX_255"
            size="sm"
            class="form-control"
            v-model="conformiteForm.protractor"
          />
        </b-form-group>

        <b-form-group label="Type d'enquête" label-cols-sm="5" label-for="typeOfInvestigation">
          <b-form-radio-group
            id="typeOfInvestigation"
            buttons
            v-model="conformiteForm.typeOfInvestigation"
            :options="optionsTypeOfInvestigation"
            size="lg"
            button-variant="outline-info"
            name="typeOfInvestigation"
          />
        </b-form-group>
        <b-form-group label="Type de visite" label-cols-sm="5" label-for="typeOfVisit">
          <b-form-radio-group
            id="typeOfVisit"
            buttons
            v-model="conformiteForm.typeOfVisit"
            :options="optionsTypeOfVisit"
            size="lg"
            button-variant="outline-info"
            name="typeOfVisit"
          />
        </b-form-group>
        <b-form-group label="Type de contrôle" label-cols="5" label-for="typeOfControl">
          <template v-if="loaderData">
            <strong>{{$t('loading')}}</strong>
            <b-spinner class="ml-auto"></b-spinner>
          </template>

          <multiselect
            v-else
            id="typeOfControl"
            v-model="conformiteForm.typeOfControl"
            name="typeOfControl"
            :options="optionsTypeOfControl"
            :searchable="false"
            :multiple="true"
            track-by="id"
            label="label"
          />
        </b-form-group>
        <b-form-checkbox
          plain
          id="proprieteNonRaccordeAssainissement"
          name="proprieteNonRaccordeAssainissement"
          v-model="conformiteForm.proprieteNonRaccordeAssainissement"
          value="1"
          class="form-group row"
        >La propriété est raccordée à un réseau public d’assainissement</b-form-checkbox>

        <b-form-checkbox
          plain
          id="eauxPluvialeNonRaccordeAssainissement"
          name="eauxPluvialeNonRaccordeAssainissement"
          v-model="conformiteForm.eauxPluvialeNonRaccordeAssainissement"
          value="1"
          class="form-group row"
        >Les eaux pluviales de la propriété sont raccordées à un réseau d'eaux pluviales</b-form-checkbox>

        <b-form-group
          label="Les eaux usées et eaux pluviales sont séparées jusqu’en limite de propriété"
          label-cols-sm="5"
          label-for="eauxUseesEtPluvialesSeparees"
        >
          <b-form-radio-group
            id="eauxUseesEtPluvialesSeparees"
            buttons
            v-model="conformiteForm.eauxUseesEtPluvialesSeparees"
            :options="options"
            size="lg"
            button-variant="outline-info"
            name="eauxUseesEtPluvialesSeparees"
          />
        </b-form-group>
        <div class="block">
          <b-form-checkbox
            plain
            id="raccordementEuEp"
            name="raccordementEuEp"
            v-model="conformiteForm.raccordementEuEp"
            value="1"
            class="form-group row"
          >Raccordement EU dans EP</b-form-checkbox>
          <div class="block" v-if="conformiteForm.raccordementEuEp == isShown('raccordementEuEp')">
            <b-form-group
              class="selectNumeroRaccordement"
              label="Numéro(s) de branchement EU dans EP"
              label-cols="4"
              label-for="numeroRaccordementEuEp"
            >
              <template v-if="loaderData">
                <strong>{{$t('loading')}}</strong>
                <b-spinner class="ml-auto"></b-spinner>
              </template>

              <multiselect
                v-else
                id="numeroRaccordementEuEp"
                v-model="conformiteForm.numeroRaccordementEuEp"
                name="numeroRaccordementEuEp"
                :options="optionsNumeroRaccordement"
                :searchable="false"
                :multiple="true"
                track-by="id"
                label="label"
              />
            </b-form-group>
            <b-form-checkbox
              plain
              id="raccordementEuEpExistant"
              name="raccordementEuEpExistant"
              v-model="conformiteForm.raccordementEuEpExistant"
              value="1"
              class="form-group row"
            >Semble envisageable de reconnecter les EU à un branchement EU existant</b-form-checkbox>

            <b-form-checkbox
              plain
              id="raccordementEuEpNew"
              name="raccordementEuEpNew"
              v-model="conformiteForm.raccordementEuEpNew"
              value="1"
              class="form-group row"
            >Semble nécessaire de faire une demande de réalisation d’un branchement neuf EU</b-form-checkbox>
          </div>
          <b-form-checkbox
            plain
            id="raccordementEpEu"
            name="raccordementEpEu"
            v-model="conformiteForm.raccordementEpEu"
            value="1"
            class="form-group row"
          >Raccordement EP dans EU</b-form-checkbox>
          <div class="block" v-if="conformiteForm.raccordementEpEu == isShown('raccordementEpEu')">
            <b-form-group
              class="selectNumeroRaccordement"
              label="Numéro(s) de branchement EP dans EU"
              label-cols="4"
              label-for="numeroRaccordementEpEu"
            >
              <template v-if="loaderData">
                <strong>{{$t('loading')}}</strong>
                <b-spinner class="ml-auto"></b-spinner>
              </template>

              <multiselect
                v-else
                id="numeroRaccordementEpEu"
                v-model="conformiteForm.numeroRaccordementEpEu"
                name="numeroRaccordementEpEu"
                :options="optionsNumeroRaccordement"
                :searchable="false"
                :multiple="true"
                track-by="id"
                label="label"
              />
            </b-form-group>
            <b-form-checkbox
              plain
              id="infiltrerPartieEP"
              name="infiltrerPartieEP"
              v-model="conformiteForm.infiltrerPartieEP"
              value="1"
              class="form-group row"
            >Semble envisageable d’infiltrer tout ou une partie des EP</b-form-checkbox>
            <b-form-checkbox
              plain
              id="recupererPartieEP"
              name="recupererPartieEP"
              v-model="conformiteForm.recupererPartieEP"
              value="1"
              class="form-group row"
            >Semble envisageable de récupérer toute une partie des EP</b-form-checkbox>
            <b-form-checkbox
              plain
              id="reconnecterEpGargouille"
              name="reconnecterEpGargouille"
              v-model="conformiteForm.reconnecterEpGargouille"
              value="1"
              class="form-group row"
            >
              Semble envisageable de reconnecter les EP à une gargouille
              existante
            </b-form-checkbox>
            <b-form-checkbox
              plain
              id="reconnecterEpExistEp"
              name="reconnecterEpExistEp"
              v-model="conformiteForm.reconnecterEpExistEp"
              value="1"
              class="form-group row"
            >
              Semble envisageable de reconnecter les EP à un branchement EP
              existant
            </b-form-checkbox>
            <b-form-checkbox
              plain
              id="realisationBranchementEpNeuf"
              name="realisationBranchementEpNeuf"
              v-model="conformiteForm.realisationBranchementEpNeuf"
              value="1"
              class="form-group row"
            >
              Semble nécessaire de faire une demande de réalisation d’un branchement neuf
              EP
            </b-form-checkbox>
            <b-form-checkbox
              plain
              id="reseauSeparatif"
              name="reseauSeparatif"
              v-model="conformiteForm.reseauSeparatif"
              value="1"
              class="form-group row"
            >Réseau séparatif</b-form-checkbox>
            <div class="block" v-if="conformiteForm.reseauSeparatif == isShown('reseauSeparatif')">
              <b-form-group
                label="Surface de la parcelle (m²) "
                label-cols="5"
                label-size="md"
                label-for="surfaceParcelle"
              >
                <b-form-input
                  id="surfaceParcelle"
                  name="surfaceParcelle"
                  type="number"
                  min="0"
                  size="sm"
                  step=".01"
                  class="form-control"
                  v-model="conformiteForm.surfaceParcelle"
                />
              </b-form-group>
              <b-form-group
                label="Surface collectée par la grille connectée aux EU (m²)"
                label-cols="5"
                label-size="md"
                label-for="surfaceCollecte"
              >
                <b-form-input
                  id="surfaceCollecte"
                  name="surfaceCollecte"
                  type="number"
                  min="0"
                  size="sm"
                  step=".01"
                  class="form-control"
                  v-model="conformiteForm.surfaceCollecte"
                />
              </b-form-group>
              <b-form-checkbox
                plain
                id="derogationAccorde"
                name="derogationAccorde"
                v-model="conformiteForm.derogationAccorde"
                value="1"
                class="form-group row"
              >
                Dérogation accordée car les eaux pluviales sont raccordées au réseau d’eaux usées
                uniquement par une grille ou un siphon récupérant les EP de surfaces n’excédant pas 10%
                de la surface totale de la parcelle, dans la limite de 20 m²
              </b-form-checkbox>
            </div>
          </div>
        </div>
        <b-form-checkbox
          plain
          id="rejetDomestique"
          name="rejetDomestique"
          v-model="conformiteForm.rejetDomestique"
          value="1"
          class="form-group row"
        >Rejets domestiques</b-form-checkbox>
        <div
          class="block btn-w"
          v-if="conformiteForm.rejetDomestique == isShown('rejetDomestique')"
        >
          <b-form-group
            label="Des eaux usées transitent par la gouttière"
            label-cols-sm="5"
            label-for="eauxUseesTransitentGouttiere"
          >
            <b-form-radio-group
              id="eauxUseesTransitentGouttiere"
              buttons
              v-model="conformiteForm.eauxUseesTransitentGouttiere"
              :options="options"
              size="lg"
              button-variant="outline-info"
              name="eauxUseesTransitentGouttiere"
            />
          </b-form-group>
          <b-form-group
            label="Les descentes d’eaux usées sont prolongées d’évents"
            label-cols-sm="5"
            label-for="eauxUseesProlongeesEvents"
          >
            <b-form-radio-group
              id="eauxUseesProlongeesEvents"
              buttons
              v-model="conformiteForm.eauxUseesProlongeesEvents"
              :options="options"
              size="lg"
              button-variant="outline-info"
              name="eauxUseesProlongeesEvents"
            />
          </b-form-group>
          <b-form-group
            label="L’ensemble des eaux usées est raccordé à un réseau public unitaire ou d’eaux usées"
            label-cols-sm="5"
            label-for="eauxUseesRaccordeesRpu"
          >
            <b-form-radio-group
              id="eauxUseesRaccordeesRpu"
              buttons
              v-model="conformiteForm.eauxUseesRaccordeesRpu"
              :options="options"
              size="lg"
              button-variant="outline-info"
              name="eauxUseesRaccordeesRpu"
            />
          </b-form-group>
          <b-form-group
            label="L’étanchéité des installations est respectée (uniquement pour les canalisations
                contrôlées)"
            label-cols-sm="5"
            label-for="etancheiteRespectee"
          >
            <b-form-radio-group
              id="etancheiteRespectee"
              buttons
              v-model="conformiteForm.etancheiteRespectee"
              :options="options"
              size="lg"
              button-variant="outline-info"
              name="etancheiteRespectee"
            />
          </b-form-group>
          <b-form-group
            label="L’ensemble des appareils sanitaires est siphonné"
            label-cols-sm="5"
            label-for="sanitairesSiphonne"
          >
            <b-form-radio-group
              id="sanitairesSiphonne"
              buttons
              v-model="conformiteForm.sanitairesSiphonne"
              :options="options"
              size="lg"
              button-variant="outline-info"
              name="sanitairesSiphonne"
            />
          </b-form-group>

          <b-form-group
            label="Des installations sanitaires sont situées sous niveau de chaussée"
            label-cols-sm="5"
            label-for="sanitairesSousNiveauChaussee"
          >
            <b-form-radio-group
              id="sanitairesSousNiveauChaussee"
              buttons
              v-model="conformiteForm.sanitairesSousNiveauChaussee"
              :options="options"
              size="lg"
              button-variant="outline-info"
              name="sanitairesSousNiveauChaussee"
            />
          </b-form-group>
          <b-form-group
            label="Ces installations sont équipées d’un système de protection contre le reflux"
            label-cols-sm="5"
            label-for="installationProtectionReflux"
            v-if="conformiteForm.sanitairesSousNiveauChaussee == isShown('sanitairesSousNiveauChaussee')"
          >
            <b-form-radio-group
              id="installationProtectionReflux"
              buttons
              v-model="conformiteForm.installationProtectionReflux"
              :options="options"
              size="lg"
              button-variant="outline-info"
              name="installationProtectionReflux"
            />
          </b-form-group>
          <b-form-group
            label="Il existe un (ou des) appareil(s) interdit(s) par le Règlement du Service"
            label-cols-sm="5"
            label-for="appareilsInterditReglement"
          >
            <b-form-radio-group
              id="appareilsInterditReglement"
              buttons
              v-model="conformiteForm.appareilsInterditReglement"
              :options="options"
              size="lg"
              button-variant="outline-info"
              name="appareilsInterditReglement"
            />
          </b-form-group>
          <div class="block">
            <b-form-group
              label="Lesquels"
              label-cols="5"
              label-for="appareilsInterditReglementText"
              v-if="conformiteForm.appareilsInterditReglement == isShown('appareilsInterditReglement')"
            >
              <b-form-input
                id="appareilsInterditReglementText"
                name="appareilsInterditReglementText"
                type="text"
                :maxlength="$MAX_255"
                size="sm"
                class="form-control"
                v-model="conformiteForm.appareilsInterditReglementText"
              />
            </b-form-group>
          </div>
          <b-form-group
            label="Présence d’un (ou plusieurs) ouvrage(s) de gestion des eaux pluviales à la parcelle"
            label-cols-sm="5"
            label-for="gestionEpParcelle"
          >
            <b-form-radio-group
              id="gestionEpParcelle"
              buttons
              v-model="conformiteForm.gestionEpParcelle"
              :options="optionsGeneric"
              size="lg"
              button-variant="outline-info"
              name="gestionEpParcelle"
            />
            <span
              class="mg-l-4 btn btn-danger btn-lg"
              @click="conformiteForm.gestionEpParcelle=null"
            >
              <i class="fa fa-times-circle"></i>
            </span>
          </b-form-group>
          <div class="block">
            <b-form-group
              label="Lesquels"
              label-cols="5"
              label-for="gestionEpParcelleSelection"
              v-if="conformiteForm.gestionEpParcelle == isShown('gestionEpParcelle')"
            >
              <template v-if="loaderData">
                <strong>{{$t('loading')}}</strong>
                <b-spinner class="ml-auto"></b-spinner>
              </template>

              <multiselect
                v-else
                id="gestionEpParcelleSelection"
                v-model="conformiteForm.gestionEpParcelleSelection"
                name="gestionEpParcelleSelection"
                :options="optionsGestionEp"
                :searchable="false"
                :multiple="true"
                track-by="value"
                label="name"
              />
            </b-form-group>

            <b-form-group
              label="En bon fonctionnement"
              label-cols-sm="5"
              label-for="rejetDomestiqueBonFonctionnement"
              v-if="conformiteForm.gestionEpParcelle == isShown('gestionEpParcelle')"
            >
              <b-form-radio-group
                id="rejetDomestiqueBonFonctionnement"
                buttons
                v-model="conformiteForm.rejetDomestiqueBonFonctionnement"
                :options="options"
                size="lg"
                button-variant="outline-info"
                name="rejetDomestiqueBonFonctionnement"
              />
            </b-form-group>
            <b-form-group
              label="Accessible(s)"
              label-cols-sm="5"
              label-for="rejetDomestiqueAccessible"
              v-if="conformiteForm.gestionEpParcelle == isShown('gestionEpParcelle')"
            >
              <b-form-radio-group
                id="rejetDomestiqueAccessible"
                buttons
                v-model="conformiteForm.rejetDomestiqueAccessible"
                :options="optionsGeneric"
                size="lg"
                button-variant="outline-info"
                name="rejetDomestiqueAccessible"
              />
              <span
                class="mg-l-4 btn btn-danger btn-lg"
                @click="conformiteForm.rejetDomestiqueAccessible=null"
              >
                <i class="fa fa-times-circle"></i>
              </span>
            </b-form-group>
            <b-form-group
              label="Entretenu(s) (pièces justificatives)"
              label-cols-sm="5"
              label-for="rejetDomestiqueEntretenu"
              v-if="conformiteForm.gestionEpParcelle == isShown('gestionEpParcelle')"
            >
              <b-form-radio-group
                id="rejetDomestiqueEntretenu"
                buttons
                v-model="conformiteForm.rejetDomestiqueEntretenu"
                :options="options"
                size="lg"
                button-variant="outline-info"
                name="rejetDomestiqueEntretenu"
              />
            </b-form-group>
          </div>
          <b-form-group label="Autres remarques" label-cols="5" label-for="rejetDomestiqueRemarque">
            <b-form-textarea
              id="rejetDomestiqueRemarque"
              name="rejetDomestiqueRemarque"
              class="form-control"
              v-model="conformiteForm.rejetDomestiqueRemarque"
              rows="3"
              max-rows="6"
              :maxlength="$MAX_2000"
            />
          </b-form-group>
        </div>
        <b-form-checkbox
          plain
          id="rejetNonDomestique"
          name="rejetNonDomestique"
          v-model="conformiteForm.rejetNonDomestique"
          value="1"
          class="form-group row"
        >Rejets non-domestiques</b-form-checkbox>
        <div
          class="block btn-w"
          v-if="conformiteForm.rejetNonDomestique == isShown('rejetNonDomestique')"
        >
          <b-form-group
            label="Activité de restauration"
            label-cols-sm="5"
            label-for="activiteRestauration"
          >
            <b-form-radio-group
              id="activiteRestauration"
              buttons
              v-model="conformiteForm.activiteRestauration"
              :options="options"
              size="lg"
              button-variant="outline-info"
              name="activiteRestauration"
            />
          </b-form-group>

          <b-form-group
            label="Activité type garage, station de lavage, etc."
            label-cols-sm="5"
            label-for="activiteGarageLavage"
          >
            <b-form-radio-group
              id="activiteGarageLavage"
              buttons
              v-model="conformiteForm.activiteGarageLavage"
              :options="options"
              size="lg"
              button-variant="outline-info"
              name="activiteGarageLavage"
            />
          </b-form-group>

          <b-form-group label="Parking " label-cols-sm="5" label-for="parking">
            <b-form-radio-group
              id="parking"
              buttons
              v-model="conformiteForm.parking"
              :options="options"
              size="lg"
              button-variant="outline-info"
              name="parking"
            />
          </b-form-group>
          <div class="block">
            <b-form-group
              label="Nombre de places"
              label-cols="5"
              label-size="md"
              label-for="parkingNbPlace"
              v-if="conformiteForm.parking == isShown('parking')"
            >
              <b-form-input
                id="parkingNbPlace"
                name="parkingNbPlace"
                type="number"
                min="0"
                size="sm"
                class="form-control"
                v-model="conformiteForm.parkingNbPlace"
              />
            </b-form-group>
          </div>

          <b-form-group
            label="Autre activité non-domestique"
            label-cols-sm="5"
            label-for="autreActiviteNonDomestiques"
          >
            <b-form-radio-group
              id="autreActiviteNonDomestiques"
              buttons
              v-model="conformiteForm.autreActiviteNonDomestiques"
              :options="options"
              size="lg"
              button-variant="outline-info"
              name="autreActiviteNonDomestiques"
            />
          </b-form-group>
          <div class="block">
            <b-form-group
              label="Laquelle"
              label-cols="5"
              label-for="autreActiviteNonDomestiquesText"
              v-if="conformiteForm.autreActiviteNonDomestiques == isShown('autreActiviteNonDomestiques')"
            >
              <b-form-input
                id="autreActiviteNonDomestiquesText"
                name="autreActiviteNonDomestiquesText"
                type="text"
                :maxlength="$MAX_255"
                size="sm"
                class="form-control"
                v-model="conformiteForm.autreActiviteNonDomestiquesText"
              />
            </b-form-group>
          </div>
          <b-form-group
            label="Il existe un (ou des) équipement(s) de prétraitement"
            label-cols-sm="5"
            label-for="equipementsPretraitement"
          >
            <b-form-radio-group
              id="equipementsPretraitement"
              buttons
              v-model="conformiteForm.equipementsPretraitement"
              :options="options"
              size="lg"
              button-variant="outline-info"
              name="equipementsPretraitement"
            />
          </b-form-group>
          <div class="block">
            <b-form-group
              label="Lequel(Lesquels)"
              label-cols-sm="5"
              label-for="equipementsPretraitementSelection"
              v-if="conformiteForm.equipementsPretraitement == isShown('equipementsPretraitement')"
            >
              <b-form-checkbox-group
                id="equipementsPretraitementSelection"
                buttons
                class="btn-group-vertical"
                v-model="conformiteForm.equipementsPretraitementSelection"
                name="equipementsPretraitementSelection"
                button-variant="outline-info"
                size="lg"
              >
                <b-form-checkbox
                  v-for="equipment in getPreTreatmentEquipments"
                  :key="equipment.code"
                  :value="equipment.code"
                >{{ equipment.internalLabel }}</b-form-checkbox>
              </b-form-checkbox-group>
            </b-form-group>
            <b-form-group
              label="Autre"
              label-cols="5"
              label-for="equipementsPretraitementAutre"
              v-if="conformiteForm.equipementsPretraitementSelection && conformiteForm.equipementsPretraitementSelection.includes(isShown('equipementsPretraitementSelection'))"
            >
              <b-form-input
                id="equipementsPretraitementAutre"
                name="equipementsPretraitementAutre"
                type="text"
                :maxlength="$MAX_255"
                size="sm"
                class="form-control"
                v-model="conformiteForm.equipementsPretraitementAutre"
              />
            </b-form-group>
          </div>
          <h4
            v-if="conformiteForm.equipementsPretraitement == isShown('equipementsPretraitement')"
          >{{ $t('infoEquipement') }}</h4>
          <div
            class="block"
            v-if="conformiteForm.equipementsPretraitement == isShown('equipementsPretraitement')"
          >
            <b-form-group
              label="En bon fonctionnement"
              label-cols-sm="5"
              label-for="rejetNonDomestiqueBonFonctionnement"
            >
              <b-form-radio-group
                id="rejetNonDomestiqueBonFonctionnement"
                buttons
                v-model="conformiteForm.rejetNonDomestiqueBonFonctionnement"
                :options="options"
                size="lg"
                button-variant="outline-info"
                name="rejetNonDomestiqueBonFonctionnement"
              />
            </b-form-group>

            <b-form-group
              label="Accessible(s)"
              label-cols-sm="5"
              label-for="rejetNonDomestiqueAccessible"
            >
              <b-form-radio-group
                id="rejetNonDomestiqueAccessible"
                buttons
                v-model="conformiteForm.rejetNonDomestiqueAccessible"
                :options="optionsGeneric"
                size="lg"
                button-variant="outline-info"
                name="rejetNonDomestiqueAccessible"
              />
              <span
                class="mg-l-4 btn btn-danger btn-lg"
                @click="conformiteForm.rejetNonDomestiqueAccessible=null"
              >
                <i class="fa fa-times-circle"></i>
              </span>
            </b-form-group>

            <b-form-group
              label="Entretenu(s) (pièces justificatives)"
              label-cols-sm="5"
              label-for="rejetNonDomestiqueEntretenu"
            >
              <b-form-radio-group
                id="rejetNonDomestiqueEntretenu"
                buttons
                v-model="conformiteForm.rejetNonDomestiqueEntretenu"
                :options="options"
                size="lg"
                button-variant="outline-info"
                name="rejetNonDomestiqueEntretenu"
              />
            </b-form-group>
          </div>
          <b-form-group
            label="Autres remarques"
            label-cols="5"
            label-for="rejetNonDomestiqueRemarque"
          >
            <b-form-textarea
              id="rejetNonDomestiqueRemarque"
              name="rejetNonDomestiqueRemarque"
              class="form-control"
              v-model="conformiteForm.rejetNonDomestiqueRemarque"
              rows="3"
              max-rows="6"
              :maxlength="$MAX_2000"
            />
          </b-form-group>
        </div>
      </div>
    </div>

    <!--
    <div class="panel panel-info mg-b-15">
      <div class="panel-heading">{{ $t('dessinTech') }}</div>
      <div class="panel-body">
        <leaf :propertyAddress="propertyAddress"></leaf>
      </div>
    </div>
    -->

    <div class="panel panel-info mg-b-15">
      <div class="panel-heading">{{ $t('technical_drawings') }}</div>
      <div class="panel-body">
        <div class="row">
          <div class="col-sm-6">
            <a v-on:click.prevent="openDrawio(technicalDesignUrl)" href="#" class="btn btn btn-cta btn-secondary btn-block text-center">
              {{ $t('open_technical_drawing') }}
            </a>
          </div>
          <input id="technicalDrawingXml" name="technicalDrawingXml" type="hidden" v-model="conformiteForm.technicalDrawingXml">
          <input id="technicalDrawingImage" name="technicalDrawingImage" type="hidden" v-model="conformiteForm.technicalDrawingImage">
        </div>
        <div class="row">
          <div class="col-sm-6">
            <div v-if="isDrawingImageReady(this.conformiteForm.technicalDrawingImage)" class="text-center">
              <br>
              <img v-bind:src="this.conformiteForm.technicalDrawingImage" class="img-drawing">
              <br>
              <a v-if="this.controlId" v-bind:href="this.getFileUrl(this.controlId, this.technicalDrawingImageId)" target="_blank">{{ $t('download') }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="panel panel-info mg-b-15">
      <div class="panel-heading">{{ $t('conclusion') }}</div>
      <div class="panel-body">
            <b-container fluid>
              <b-row>
                  <b-col sm="2">
                    <label for="textarea-small">{{$t('controleRemarque')}}</label>
                  </b-col>
                  <b-col sm="10">
                        <textarea
                          name="controleRemarque"
                          size="sm"
                          class="form-control"
                          v-model="conformiteForm.controleRemarque"
                          rows="20"
                          cols="20"
                          max-rows="255"
                          :maxlength="$MAX_2000"
                          style="min-height:200px"
                        />
                  </b-col>
                  <b-col sm="12" class="text-right"><span>{{charactersRemaining}}/{{$MAX_2000}}</span></b-col>
               </b-row>
            </b-container>


        <b-form-group>
          <b-form-radio-group
            id="controlStatus"
            buttons
            class="status-controls"
            v-model="conformiteForm.controlStatus"
            size="lg"
            name="controlStatus"
          >
            <b-form-radio
              value="conforme"
              button-variant="outline-success"
              class="status-controls-pad"
            >CONFORME</b-form-radio>
            <b-form-radio
              value="non-conforme"
              button-variant="outline-danger"
              class="status-controls-pad"
            >NON CONFORME</b-form-radio>
            <b-form-radio
              value="non-conforme-sans-dysfonctionnement"
              button-variant="outline-warning"
            >NON CONFORME SANS DYSFONCTIONNEMENT</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </div>
    </div>

    <div class="panel panel-info">
      <div class="panel-heading">{{ $t('signature') }}</div>
      <div class="panel-body">
        <div class="col-xs-12 col-md-4">
          <label>{{ $t('signataire') }} :</label>
        </div>
        <div class="col-xs-12 col-md-8">
          <select
            v-model="signator"
            v-on:change="onChangeSignatureContact($event)"
            class="form-control"
          >
            <option value>{{ $t('chooseContact') }}</option>
            <option
              v-for="contact in property.contacts"
              :key="contact.id"
              :value="((contact.name || '') + ' ' + (contact.firstName || '')).trim()"
            >{{ ((contact.name || '') + ' ' + (contact.firstName || '')).trim() }}</option>
            <option value="custom">Autre</option>
          </select>
        </div>

        <div class="row">&nbsp;</div>

        <div class="col-xs-12 col-md-4">
          <label></label>
        </div>
        <div class="col-xs-12 col-md-8">
          <input
            v-model="conformiteForm.signator"
            v-bind:disabled="! signatureContactCustom"
            type="text"
            :maxlength="$MAX_255"
            class="form-control"
            v-on:blur="onSignator"
          />
        </div>

        <div class="row">&nbsp;</div>

        <div class="col-xs-12 col-md-4">
          <label></label>
        </div>
        <div class="col-xs-12 col-md-8">
          <button
            type="button"
            v-bind:class="{'disabled' : dispalyAddSignature }"
            class="btn btn btn-cta s-btn btn-secondary float-right"
            data-backdrop="static"
            data-keyboard="false"
            data-toggle="modal"
            data-target="#signatureModal"
          >{{ $t('addSignature') }}</button>
        </div>

        <div class="row">&nbsp;</div>

        <div class="col-xs-12 col-md-4">
          <label></label>
        </div>
        <div class="col-xs-12 col-md-8">
          <div>
            <img
              v-if="conformiteForm.signature && conformiteForm.signature.startsWith('data:')"
              v-bind:src="conformiteForm.signature"
              class="signature"
            />
            <img
              v-else-if="this.signatureId !== null && this.signatureId !== 'undefined'"
              v-bind:src="'/fr/file/' + this.controlId + '/preview/' + this.signatureId"
              class="signature"
            />
          </div>

          <br />
          {{ signator }}
          <br />
          {{ conformiteForm.signatureDateTime }}
        </div>

        <div
          class="modal"
          id="signatureModal"
          tabindex="-1"
          role="dialog"
          aria-labelledby="signatureModalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
            <div class="modal-content">
              <div class="modal-body">
                <div class="row">
                  <div class="col-sm-6">
                    <b>Nom et Prénom:</b>
                    {{ signator }}
                    <br />
                    <b>Date et Heure:</b>
                    {{ currentDateTime() }}
                    <br />
                  </div>
                  <div class="col-sm-6">
                    <b>Adresse :</b>
                    <div
                      v-if="property.address"
                    >{{ property.address.street + ', ' + property.address.numberStreet + ', ' + property.address.zipCode+ ', ' + property.address.town}}</div>
                    <br />
                    <b>Résultat du contrôle :</b>
                    {{ conformiteForm.controlStatus }}
                    <br />
                  </div>
                </div>

                <br />

                <SignaturePad
                  v-bind:signature="conformiteForm.signature"
                  v-bind:signatureDateTime="conformiteForm.signatureDateTime"
                  v-bind:signatureDateTimeOriginal="conformiteForm.signatureDateTime"
                  v-on:emitSignaturePadData="onSignaturePadData"
                ></SignaturePad>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-primary" data-dismiss="modal">Valider</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Dropzone from '../Dropzone';
import { mapState, mapGetters } from 'vuex';
import { VALUE_TRUE, VALUE_YES, VALUE_OTHER, VALUE_NO } from '../../constants/params';
import SignaturePad from '../../communs/SignaturePad';
//import leaf from '@/leaf/map.vue';
import { currentDateTime } from '@/utils/formatDate.js';
import { getEndpoint } from '../../store/endpoints';
import axios from 'axios';

export default {
  Name: 'ConformiteFields',
  props: {
    conformiteForm: { required: true },
    title: { type: String, required: true },
    propertyAddress: { required: false },
  },
  components: {
    filesDropzone: Dropzone,
    SignaturePad,
//    leaf,
  },
  mounted: function() {
    this.fetchStormWaterStructure();
    this.fetchPreTreatmentEquipments();
  },
  data: () => ({
    loaderData: true,
    options: [
      { text: 'Oui', value: 'oui' },
      { text: 'Non', value: 'non' },
      { text: 'Indéterminé', value: 'impossible' },
    ],
    optionsGeneric: [
      { text: 'Oui', value: 'oui' },
      { text: 'Non', value: 'non' },
    ],
    optionsEquipements: [
      {
        value: 'bacGraisse',
        text: 'Bac à graisse',
      },
      {
        value: 'separateurHydro',
        text: 'Séparateur à hydrocarbure',
      },
      {
        value: 'autre',
        text: 'Autre',
      },
    ],
    optionsTypeOfInvestigation: [
      {
        value: 'ac',
        text: 'AC',
      },
      {
        value: 'ar',
        text: 'AR',
      },
    ],
    optionsTypeOfVisit: [
      {
        value: 'init-visit',
        text: 'Visite initiale',
      },
      {
        value: 'cons-visit',
        text: 'Contre-visite',
      },
      {
        value: 'visit-advice',
        text: 'Visite conseil',
      },
    ],
    optionsTypeOfControl: [
      {
        id: 'mutation',
        label: 'Mutation',
      },
      {
        id: 'separtif',
        label: 'Séparatif',
      },
      {
        id: 'nd',
        label: 'ND',
      },
      {
        id: 'other',
        label: 'Autre',
      },
    ],
    optionsGestionEp: [],
    signatureId: null,
    signator: null,
    signatureContactCustom: false,
    dispalyAddSignature: true,
    tempUuid: null,
    userTempToken: null,
    technicalDesignUrl: null,
    synopticDesignUrl: null,
    drawioConfig: null,
    technicalDrawingXmlId: null,
    synopticDrawingXmlId: null,
    technicalDrawingImageId: null,
    synopticDrawingImageId: null,
  }),
  computed: {
    ...mapState({
      controlId: state => state.route.params.controlId,
      property: state => state.refProperties.property,
    }),
    ...mapGetters(['getPreTreatmentEquipments', 'getStormWaterStructure']),
    charactersRemaining: function () {
      if(   this.conformiteForm.controleRemarque )
       {
         return this.conformiteForm.controleRemarque.length;
       }
       return 0;
      },
    optionsNumeroRaccordement: function () {
      if (! (this.property && this.property.raccordement && Array.isArray(this.property.raccordement.connections))) {
        return [];
      }

      return this.property
        .raccordement
        .connections
        .map((connection) => {
          const {id, connectionNumber, networkType, networkProperty} = connection;

          return {
            id,
            label: `${connectionNumber} - ${networkType} - ${networkProperty}`,
          };
        });
    },
  },
  methods: {
    currentDateTime,
    isDrawingImageReady(drawingImage)
    {
      return drawingImage && drawingImage.startsWith('data:');
    },
    onSignator() {
      if (this.conformiteForm.signator) {
        this.dispalyAddSignature = false;
      } else {
        this.dispalyAddSignature = true;
      }
    },
    onChangeSignatureContact(event) {
      if (event.target.value === 'custom') {
        this.signator = '';
        this.conformiteForm.signator = this.signator;
        this.signatureContactCustom = true;
        this.dispalyAddSignature = true;
      } else {
        this.signator = event.target.value;
        this.conformiteForm.signator = this.signator;
        this.signatureContactCustom = false;
        this.dispalyAddSignature = false;
      }
      if (!this.signator) {
        this.dispalyAddSignature = true;
      }
    },
    onSignaturePadData(data) {
      this.conformiteForm.signature = data.signature;
      this.conformiteForm.signatureDateTime = data.signatureDateTime;
      this.$forceUpdate();
    },
    fetchStormWaterStructure() {
      return this.$store
        .dispatch('fetchStormWaterStructure')
        .then(() => ((this.loaderData = false), (this.optionsGestionEp = this.getStormWaterStructure)));
    },
    fetchPreTreatmentEquipments() {
      return this.$store.dispatch('fetchPreTreatmentEquipments').then(() => (this.loaderData = false));
    },
    isShownRaccordement: function() {
      if (
        this.conformiteForm.eauxUseesEtPluvialesSeparees &&
        (this.conformiteForm.eauxUseesEtPluvialesSeparees === 'oui' ||
          this.conformiteForm.eauxUseesEtPluvialesSeparees === 'impossible')
      ) {
        return false;
      } else if (this.conformiteForm.eauxUseesEtPluvialesSeparees) {
        return true;
      }
      return false;
    },
    isShown: function(value) {
      const options = {
        reseauSeparatif: VALUE_TRUE,
        rejetDomestique: VALUE_TRUE,
        appareilsInterditReglement: VALUE_YES,
        gestionEpParcelle: VALUE_YES,
        rejetNonDomestique: VALUE_TRUE,
        parking: VALUE_YES,
        autreActiviteNonDomestiques: VALUE_YES,
        equipementsPretraitement: VALUE_YES,
        equipementsPretraitementSelection: VALUE_OTHER,
        raccordementEuEp: VALUE_TRUE,
        raccordementEpEu: VALUE_TRUE,
        eauxUseesEtPluvialesSeparees: VALUE_NO,
        sanitairesSousNiveauChaussee: VALUE_YES,
      };

      if (this.conformiteForm.gestionEpParcelle === 'non') {
        this.conformiteForm.gestionEpParcelleSelection = null;
        this.conformiteForm.rejetDomestiqueBonFonctionnement = null;
        this.conformiteForm.rejetDomestiqueAccessible = null;
        this.conformiteForm.rejetDomestiqueEntretenu = null;
      }

      if (this.conformiteForm.sanitairesSousNiveauChaussee !== 'oui') {
        this.conformiteForm.installationProtectionReflux = null;
      }

      return options[value];
    },
    getTmpDiagram: function () {
      // Get the saved temporay diagrams contents (xml and base64 for images) and set digrams fields values
      let _this = this;

      let technicalDesignId = `technical-design-${this.tempUuid}`;

      let technicalDesignUrl = this.drawioConfig.widgetHost.replace('diagramId', technicalDesignId) + "?temp-token=" + this.userTempToken;

      // Get technical diagram and set fields values
      axios.get(technicalDesignUrl).then(response => {
        _this.conformiteForm.technicalDrawingXml = response.data.xml;
        _this.conformiteForm.technicalDrawingImage = response.data.base64Image;
        this.getDrawioConfig(this.userTempToken);
        this.$forceUpdate();
      })
      .catch(error => {
        console.log(error);
      });
    },
    getFile: function (requestId, fileId, formKey, type='', encode = '') {
      // Get diagrams file content (xml, and base64 for images) and set diagrams fields values
      let _this = this;

      const endpoint = `${getEndpoint('file', null, requestId, fileId, null).absoluteDownloadUrl}?encode=${encode}`;

      axios.get(endpoint).then(response => {
          _this.conformiteForm[formKey] = response.data;
          if (type == 'png') {
            _this.conformiteForm[formKey] = 'data:image/png;base64,' + _this.conformiteForm[formKey];
          }
      })
      .catch(error => {
        alert(error);
      });
    },
    getPropertyFile: function (fileId, formKey, type='', encode = '') {
      // Get diagrams file content (xml, and base64 for images) and set diagrams fields values
      let _this = this;

      const endpoint = `${getEndpoint('drawio', null, this.controlId, fileId, null).downloadPropertyFile}?encode=${encode}&temp-token=${this.userTempToken}`;

      axios.get(endpoint).then(response => {
          _this.conformiteForm[formKey] = response.data;
          if (type == 'png') {
            _this.conformiteForm[formKey] = 'data:image/png;base64,' + _this.conformiteForm[formKey];
            _this.$forceUpdate();
          }
      })
      .catch(error => {
        alert(error);
      });
    },
    getFileUrl: function (requestId, fileId) {
      return getEndpoint('file', null, requestId, fileId, null).absoluteDownloadUrl;
    },
    setUserTempToken: function () {
      // Get a user temporay token
      let _this = this;

      const endpoint = getEndpoint('userTempToken', null, null, null, null).get;

      axios.get(endpoint).then(response => {
          _this.userTempToken = response.data.value;
          this.$forceUpdate();
          _this.getDrawioConfig(_this.userTempToken);
      })
      .catch(error => {
        console.log(error);
      });
    },
    setDrawioUrls (drawioConfig, userTempToken) {
      // Init the drawio urls for technical
      let technicalDesignId = `technical-design-${this.tempUuid}`;

      if (this.conformiteForm.technicalDrawingXml && this.technicalDrawingXmlId) {
        this.technicalDesignUrl = `${drawioConfig.url}/?splash=0&lang=fr&drafts=0&gapi=0&db=0&od=0&tr=0&gh=0&gl=0&browser=0&p=&get-url=${this.getDrawioGetUrl(this.technicalDrawingXmlId)}&post-url=${drawioConfig.widgetHost.replace('diagramId', technicalDesignId)}?temp-token=${userTempToken}`;
      }
      else if(this.conformiteForm.technicalDrawingXml && !this.technicalDrawingXmlId)
      {
        this.technicalDesignUrl = `${drawioConfig.url}/?splash=0&lang=fr&drafts=0&gapi=0&db=0&od=0&tr=0&gh=0&gl=0&browser=0&p=&get-url=${drawioConfig.widgetHost.replace('diagramId', technicalDesignId)}/xml?temp-token=${userTempToken}&post-url=${drawioConfig.widgetHost.replace('diagramId', technicalDesignId)}?temp-token=${userTempToken}`;
      }
      else{
        if (this.property && this.property.technicalDrawingXml && this.property.technicalDrawingXml.id) {
          this.technicalDesignUrl = `${drawioConfig.url}/?splash=0&lang=fr&drafts=0&gapi=0&db=0&od=0&tr=0&gh=0&gl=0&browser=0&p=&get-url=${this.getDrawioPropertyUrl(this.property.technicalDrawingXml.id)}&post-url=${drawioConfig.widgetHost.replace('diagramId', technicalDesignId)}?temp-token=${userTempToken}`;
          this.getPropertyFile(this.property.technicalDrawingImage.id, 'technicalDrawingImage', 'png', 'base64');
          this.getPropertyFile(this.property.technicalDrawingXml.id, 'technicalDrawingXml');
        }else{
          this.technicalDesignUrl = `${drawioConfig.url}/?splash=0&lang=fr&drafts=0&gapi=0&db=0&od=0&tr=0&gh=0&gl=0&browser=0&p=&get-url=${this.getDrawioTemplateUrl('technique.drawio')}&post-url=${drawioConfig.widgetHost.replace('diagramId', technicalDesignId)}?temp-token=${userTempToken}`;
        }
      }

      this.$forceUpdate();
    },
    getDrawioConfig(userTempToken) {
      // Get the drawio configuration
      let _this = this;

      const endpoint = getEndpoint('drawio', null, this.controlId, null, null, userTempToken).config;

      axios.get(endpoint).then(response => {
          _this.drawioConfig = response.data;
          this.$forceUpdate();
          _this.setDrawioUrls(_this.drawioConfig, _this.userTempToken);
      })
      .catch(error => {
        console.log(error);
      });
    },
    uuidv4() {
      return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
      );
    },
    getDrawioGetUrl: function (fileId) {
      // Get diagrams file url
      return `${window.location.origin}${getEndpoint('drawio', null, this.controlId, fileId).file}?temp-token=${this.userTempToken}`;
    },
    getDrawioTemplateUrl: function (templateFilename) {
      // Get diagrams file url
      return `${window.location.origin}${getEndpoint('drawio', null, this.controlId, null, null, null, templateFilename).template}?temp-token=${this.userTempToken}`;
    },
    getDrawioPropertyUrl: function (fileId) {
      // Get diagrams file url
      return `${window.location.origin}${getEndpoint('drawio', null, this.controlId, fileId, null, null, null).downloadPropertyFile}?temp-token=${this.userTempToken}`;
    },
    openDrawio(url) {
      let _this = this;

      var drawioWindow = window.open(url, '_blank');

      var loop = setInterval(function() {
        if(drawioWindow.closed) {
            clearInterval(loop);
            _this.getTmpDiagram();
        }
      }, 500);
    },
  },
  created: function() {
    /*
    if (!this.$props.conformiteForm.dateOfVisit) {
      this.$props.conformiteForm.dateOfVisit = new Date().toISOString().split('T')[0];
    }
    */

    if (this.conformiteForm.signature) {
      this.signatureId = this.conformiteForm.signature;
      this.signator = this.conformiteForm.signator;
    }

    // Init diagrams fields (xml, base64 for images) if exists

    if (this.conformiteForm.technicalDrawingXml) {
      this.technicalDrawingXmlId = this.conformiteForm.technicalDrawingXml;
      this.getFile(this.controlId, this.conformiteForm.technicalDrawingXml, 'technicalDrawingXml');
    }

    if (this.conformiteForm.technicalDrawingImage) {
      this.technicalDrawingImageId = this.conformiteForm.technicalDrawingImage;
      this.getFile(this.controlId, this.conformiteForm.technicalDrawingImage, 'technicalDrawingImage', 'png', 'base64');
    }

    if (this.conformiteForm.synopticDrawingXml) {
      this.synopticDrawingXmlId = this.conformiteForm.synopticDrawingXml;
      this.getFile(this.controlId, this.conformiteForm.synopticDrawingXml, 'synopticDrawingXml');
    }

    if (this.conformiteForm.synopticDrawingImage) {
      this.synopticDrawingImageId = this.conformiteForm.synopticDrawingImage;
      this.getFile(this.controlId, this.conformiteForm.synopticDrawingImage, 'synopticDrawingImage', 'png', 'base64');
    }

    // Init the user temp token
    this.setUserTempToken();

    // Init a temporary uuid for drawio use
    this.tempUuid = this.uuidv4();
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
.signature {
  width: 50%;
}
.img-thumbnail {
  width: 100%;
}
.img-drawing {
  height: 200px;
}
.selectNumeroRaccordement {
  margin-left: 22px !important;
  align-items: center;
  .col {
    margin-left: 40px;
  }
}
</style>
